import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { NS } from '@/constants';
import { CallToActionKind } from '@/types';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './ReturnButton.module.scss';
import { URLS } from '@/constants/urls';

export const RETURN_BUTTON_ID = 'account-return-button';

const ReturnButton = ({ onClick, rbf }) => {
  const [domReady, setDomReady] = useState(false);
  const { t } = useTranslation(NS.COMMON);

  const content = (
    <CallToActionContainer
      kind={CallToActionKind.TERTIARY}
      className={styles['return-button']}
      onClick={onClick}
      rbf={rbf || null}
      id="return"
      icon={{
        url: URLS.ANGLE_LEFT_BLACK,
        alt: 'return'
      }}
    >
      {t('btn.return')}
    </CallToActionContainer>
  );

  // Wait for DOM to be ready using useEffect
  useEffect(() => {
    setDomReady(true);
  });

  // This renders the element at the specified DOM element
  // More info at https://fr.reactjs.org/docs/portals.html
  return domReady ? createPortal(
    content,
    document.getElementById(RETURN_BUTTON_ID)
  ) : null;
};

ReturnButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  rbf: PropTypes.string
};

export default ReturnButton;
